var base = require('settings/subscription/update-subscription');

Vue.component('spark-update-subscription', {
    mixins: [base],

    data() {
    	return {
    		updateDialogVisible: false,
            renewalDate: false
    	}
    },

    mounted() {
        this.getRenewalDate()
    },
    
    computed: {
    },

    created() {
		Bus.$on('updateUser', this.closeUpdateDialog);
		Bus.$on('updateTeam', this.closeUpdateDialog);
    },

    methods: {
        /**
         * Confirm the plan update with the user.
         */
        confirmPlanUpdate(plan) {
            this.confirmingPlan = plan;

            this.updateDialogVisible = true;
        },

        /**
         * Approve the plan update.
         */
        approvePlanUpdate() {
            this.closeUpdateDialog();

            this.updateSubscription(this.confirmingPlan);
        },

        closeUpdateDialog() {
        	this.updateDialogVisible = false;
        },

        getRenewalDate() {
            axios({
                method: 'GET',
                url: '/get-subscription-renewal/' + this.activeSubscription.stripe_id
            })
                .then((x) => {
                    if (x.data) {
                        this.renewalDate = moment(x.data).format('MMMM Do, YYYY');
                    }
                    else {
                        this.renewalDate = false;
                    }
                })
                .catch(errors => {
                    if (errors.response.status === 422) {
                        this.planForm.errors.set(errors.response.data.errors);
                    } else {
                        this.planForm.errors.set({plan: [__("We were unable to get your subscription renewal date. Please contact customer support.")]});
                    }
                })
                .finally(() => {
                    this.selectingPlan = null;
                });
        },
    },

});
